import { loadTitleDataSuccess } from './titleActions';


export const loadContextualizedVideoData = (titleProps) => (dispatch, getState) => {
  const { uid, itemGroups, ...rest } = titleProps;
  const titleData = { uid, ...rest };

  // Flat map of items by slug
  titleData.itemsBySlug = itemGroups.reduce((itemsObj, group) => {
    const { items, slug } = group;
    if (itemsObj.hasOwnProperty(slug)) {
      console.error(`Duplicate slug in title ${uid}: ${slug}`);
    }
    items.forEach(groupItem => {
      if (itemsObj.hasOwnProperty(groupItem.slug)) {
        console.error(`Duplicate slug in title ${uid}: ${groupItem.slug}`);
      }
      itemsObj[groupItem.slug] = { ...groupItem, group: slug };
    });
    return itemsObj;
  }, {});

  // Array defining order and hierarchy of items
  titleData.itemGroups = itemGroups.map(({ name, slug, items }) => ({
    name,
    slug,
    items: items.map(item => item.slug),
  }));

  dispatch(loadTitleDataSuccess(titleData));
};



// WEBPACK FOOTER //
// ./src/actions/contextualizedVideoTitleActions.js